import { IDrawableObject, ObjectInteraction } from "@spi/Engine/Object/ObjectManager";
import { Context } from "../Engine";
import { PropertyAnimation } from "@spi/Common/Animation/PropertyAnimation";
import { VertexBuffer } from "../Object/VertexBuffer";
import { vec4, vec3 } from "gl-matrix";
import { PathNode } from "@spi/Common/NavigationMesh";

export class VisualPathNodes implements IDrawableObject {

    animatedProperties: PropertyAnimation;
    interaction: ObjectInteraction;

    private buffer: VertexBuffer;

    constructor(public ctx: Context) {
        this.buffer = new VertexBuffer(ctx.gl.createBuffer(), ctx.gl.TRIANGLES, 0, 0);
    }

    draw(ctx: Context, picking: boolean): void {
        let gl = ctx.gl;

        let shader = ctx.setShader('debug.color-lines');

        var buffer = this.buffer;

        var floatSize = Float32Array.BYTES_PER_ELEMENT;

        gl.bindBuffer(gl.ARRAY_BUFFER, buffer.glVertexBuffer);
        gl.vertexAttribPointer(shader.attributes.vertexPosition, 3, gl.FLOAT, false, floatSize * buffer.itemSize, 0);
        gl.vertexAttribPointer(shader.attributes.vertexColor, 4, gl.FLOAT, false, floatSize * buffer.itemSize, 3 * floatSize);

        gl.uniformMatrix4fv(shader.uniforms.pMatrix, false, ctx.projectionMatrix);
        gl.uniformMatrix4fv(shader.uniforms.mvMatrix, false, ctx.modelViewMatrix);

        gl.drawArrays(this.buffer.glDrawMode, 0, buffer.itemCount);
    }

    getModes(): string[] {
        return ['main'];
    }

    getShaderReference(mode: string): string {
        return 'debug.color-lines';
    }

    public setPathNodes(nodes: PathNode[], colorLookup: (s: PathNode) => vec4) {
        let gl = this.ctx.gl;
        let geometry: number[] = [];

        let fixed = new Set<vec3 | number[]>();

        let fixZ = (vec: vec3 | number[]) => {
            if (!fixed.has(vec)) {
                vec[2] += 0.1;
                fixed.add(vec);
            }
            return vec;
        };

        for (let node of nodes) {
            let color = colorLookup(node);
            for (let face of node.generateSurface(5, 10)) {
                geometry.push(
                    ...fixZ(face.vertexA), ...color,
                    ...fixZ(face.vertexB), ...color,
                    ...fixZ(face.vertexC), ...color
                );
            }
        }

        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer.glVertexBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry), gl.DYNAMIC_DRAW);

        this.buffer.itemSize = 7;
        this.buffer.itemCount = geometry.length / 7;
    }
}

